import {Outlet, Link } from "react-router-dom";
import styles from "./styles.module.scss";
import Appbar from "./appbar";
import { ReactNode } from "react";
import { AppBarTitle, AppBarTitleContextProvider } from "./appbar/Title/context";
import useCurrentSav from "../routes/gestion-sav/Sav/Hooks/useCurrentSav";

export default function AdminLayoutBPAR({
  children,
}: {
  children?: ReactNode;
}) {

  const { sav } = useCurrentSav();
  const savId = sav?.id;

  console.log("savId", savId)

  return (
    <AppBarTitleContextProvider>
      <>
        <Appbar
          backButton={savId ? <Link to={`/sav/${savId}/reparateur`} className="tw-text-primary tw-text-sm tw-font-bold tw-me-3">Retour</Link> : null}
        />
        <AppBarTitle title="Bon pour accord/refus" />
        <div className={styles.fullWidthContainer}>
          <div className={styles.contentContainer}>
            {children || <Outlet />}
          </div>
        </div>
      </>
    </AppBarTitleContextProvider>
  );
}